import educationData from '../data/education.json';
import { Education } from '../models/education.interface';

export class EducationService {
    private education: Education[] = [];

    constructor() {
        this.education = educationData.education as Education[];
    }

    getEducation(): Education[] {
        return this.education;
    }
}

export const educationService = new EducationService();
